import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { LibraryPage, ReportConfig } from '@modules/report-generator/interfaces';
import { GraphicElement } from '@modules/report-generator/interfaces/elements';
import { BodyCompositionHumanBodyService } from './body-composition-human-body.service';
import { PortraitA4, ScalingFactor } from '@modules/report-generator/constants';

@Component({
  selector: 'app-report-graphic',
  templateUrl: './report-graphic.component.html',
  styleUrls: ['./report-graphic.component.scss'],
  providers: [BodyCompositionHumanBodyService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportGraphicComponent implements OnChanges {
  @Input() element!: GraphicElement;
  @Input() page?: LibraryPage;
  @Input() reportConfig!: ReportConfig;
  @Input() renderForPdf: boolean;

  constructor(private readonly humanBodyService: BodyCompositionHumanBodyService) {}

  testLoaded: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.didTemplateChange(changes)) {
      this.humanBodyService.clearCache();
    }

    this.testLoaded = Boolean(this.reportConfig?.test) || this.renderForPdf;
    if (this.testLoaded) {
      setTimeout(() => {
        this.renderHumanBody();
      }, 50);
    }
  }

  renderHumanBody(): void {
    const elementId = `humanBodyCtx-${this.page?.id!}-${this.element.slug}`;
    const canvas: HTMLElement | null = document.getElementById(elementId);
    if (!canvas) {
      return;
    }

    const metabolicProfile = this.reportConfig?.metabolicProfile;
    if (!metabolicProfile) {
      return;
    }

    const bodyAttributes = metabolicProfile[0]?.table_data?.body_attributes;
    if (!bodyAttributes) {
      return;
    }

    const width = (this.element.width / 100) * PortraitA4.width * ScalingFactor * 0.995;
    const height = (this.element.height / 100) * PortraitA4.width * ScalingFactor * 0.995;
    canvas.style.width = width + 'px';
    canvas.style.height = height + 'px';

    const cacheKey = elementId;
    this.humanBodyService.renderHumanBody(canvas, bodyAttributes, width * 2, height * 2, false, cacheKey);
  }

  private didTemplateChange(changes: SimpleChanges): boolean {
    const change = changes['reportConfig'];
    return (change.previousValue as ReportConfig)?.template?.id !== (change.currentValue as ReportConfig)?.template?.id;
  }
}
